/* Small bilingual dictionary for app pages (booking, technician dashboard, chat). */
export const APP_DICT = {
  en: {
    nav: { book: "Book online", login: "Technician login", dashboard: "Dashboard" },
    book: {
      tag: "Online booking",
      title: "Book a service in 60 seconds.",
      sub: "Pick a service, choose your slot, apply a coupon and confirm. A coordinator calls you to confirm.",
      service: "Service", name: "Your name", phone: "Phone", address: "Address", date: "Date", time: "Time slot",
      notes: "Notes (optional)", coupon: "Coupon code", apply: "Apply", applied: "Applied", remove: "Remove",
      subtotal: "Service price", discount: "Discount", total: "Total payable",
      pay: "Payment", online: "Pay online (Razorpay)", cod: "Pay after service",
      onlineOff: "Online payment coming soon — pay after service for now.",
      submit: "Confirm booking", paying: "Processing…", success: "Booking confirmed!",
      successSub: "Booking ID", successNote: "Our coordinator will call you shortly to confirm the slot.",
      backHome: "Back to home", whatsapp: "Share on WhatsApp", noService: "No services available right now.",
      slots: ["08:00", "10:00", "12:00", "14:00", "16:00", "18:00"],
      priceNote: "Starting price — final quote may vary with home size.",
    },
    login: {
      title: "Technician portal",
      sub: "Sign in with Google to manage your services, subscription and assigned jobs. New technicians get a 7-day free trial.",
      cta: "Continue with Google", admin: "Owner/admin? Use the same button.",
    },
    tech: {
      hello: "Hello", status: "Status", approved: "Approved", pendingApproval: "Awaiting admin approval",
      plan: "Plan", expires: "Expires", trial: "Free trial", active: "Active", expired: "Expired",
      services: "My services", servicesSub: "Turn on the services you can take. Admin assigns jobs only for ON services.",
      subscription: "Subscription", subSub: "Pay via UPI to the number below, upload the screenshot and choose a plan. Admin activates within hours.",
      upi: "Pay to UPI / phone", choosePlan: "Choose plan", upload: "Upload payment screenshot", request: "Request activation",
      requested: "Activation requested — waiting for admin", jobs: "My jobs", noJobs: "No jobs assigned yet.",
      markDone: "Mark completed", done: "Completed", phone: "Phone", savePhone: "Save", logout: "Logout",
      perDays: "days",
    },
    chat: {
      title: "OGO Assistant", sub: "Ask about services, prices or booking", placeholder: "Type your question…",
      hello: "Namaste! 🙏 Ask me about any OGO service, price or booking.",
    },
  },
  te: {
    nav: { book: "ఆన్‌లైన్ బుక్", login: "టెక్నీషియన్ లాగిన్", dashboard: "డాష్‌బోర్డ్" },
    book: {
      tag: "ఆన్‌లైన్ బుకింగ్",
      title: "60 సెకన్లలో సర్వీస్ బుక్ చేయండి.",
      sub: "సర్వీస్ ఎంచుకోండి, స్లాట్ సెలెక్ట్ చేయండి, కూపన్ అప్లై చేసి కన్ఫర్మ్ చేయండి. మా కోఆర్డినేటర్ మీకు కాల్ చేస్తారు.",
      service: "సర్వీస్", name: "మీ పేరు", phone: "ఫోన్", address: "చిరునామా", date: "తేదీ", time: "టైమ్ స్లాట్",
      notes: "గమనికలు (ఐచ్ఛికం)", coupon: "కూపన్ కోడ్", apply: "అప్లై", applied: "అప్లై అయింది", remove: "తీసివేయి",
      subtotal: "సర్వీస్ ధర", discount: "డిస్కౌంట్", total: "చెల్లించాల్సిన మొత్తం",
      pay: "చెల్లింపు", online: "ఆన్‌లైన్ పే (Razorpay)", cod: "సర్వీస్ తర్వాత చెల్లించండి",
      onlineOff: "ఆన్‌లైన్ పేమెంట్ త్వరలో — ప్రస్తుతం సర్వీస్ తర్వాత చెల్లించండి.",
      submit: "బుకింగ్ కన్ఫర్మ్", paying: "ప్రాసెస్ అవుతోంది…", success: "బుకింగ్ కన్ఫర్మ్ అయింది!",
      successSub: "బుకింగ్ ID", successNote: "స్లాట్ కన్ఫర్మ్ చేయడానికి మా కోఆర్డినేటర్ త్వరలో కాల్ చేస్తారు.",
      backHome: "హోమ్‌కి", whatsapp: "WhatsApp లో షేర్", noService: "ప్రస్తుతం సర్వీసులు అందుబాటులో లేవు.",
      slots: ["08:00", "10:00", "12:00", "14:00", "16:00", "18:00"],
      priceNote: "ప్రారంభ ధర — ఇంటి సైజును బట్టి తుది కోట్ మారవచ్చు.",
    },
    login: {
      title: "టెక్నీషియన్ పోర్టల్",
      sub: "మీ సేవలు, సబ్‌స్క్రిప్షన్ & జాబ్స్ మేనేజ్ చేయడానికి Google తో లాగిన్ అవ్వండి. కొత్త టెక్నీషియన్లకు 7 రోజుల ఉచిత ట్రయల్.",
      cta: "Google తో కొనసాగండి", admin: "ఓనర్/అడ్మిన్? ఇదే బటన్ వాడండి.",
    },
    tech: {
      hello: "నమస్తే", status: "స్థితి", approved: "ఆమోదించబడింది", pendingApproval: "అడ్మిన్ ఆమోదం కోసం వేచి ఉంది",
      plan: "ప్లాన్", expires: "గడువు", trial: "ఉచిత ట్రయల్", active: "యాక్టివ్", expired: "గడువు ముగిసింది",
      services: "నా సేవలు", servicesSub: "మీరు చేయగలిగే సేవలు ON చేయండి. ON ఉన్న సేవలకే అడ్మిన్ జాబ్స్ ఇస్తారు.",
      subscription: "సబ్‌స్క్రిప్షన్", subSub: "కింది UPI/నంబర్‌కి పే చేసి, స్క్రీన్‌షాట్ అప్‌లోడ్ చేసి ప్లాన్ ఎంచుకోండి. అడ్మిన్ కొన్ని గంటల్లో యాక్టివేట్ చేస్తారు.",
      upi: "UPI / ఫోన్‌కి పే చేయండి", choosePlan: "ప్లాన్ ఎంచుకోండి", upload: "పేమెంట్ స్క్రీన్‌షాట్ అప్‌లోడ్", request: "యాక్టివేషన్ రిక్వెస్ట్",
      requested: "రిక్వెస్ట్ పంపబడింది — అడ్మిన్ కోసం వేచి ఉంది", jobs: "నా జాబ్స్", noJobs: "ఇంకా జాబ్స్ అసైన్ కాలేదు.",
      markDone: "పూర్తయింది అని మార్క్", done: "పూర్తయింది", phone: "ఫోన్", savePhone: "సేవ్", logout: "లాగ్అవుట్",
      perDays: "రోజులు",
    },
    chat: {
      title: "OGO అసిస్టెంట్", sub: "సేవలు, ధరలు, బుకింగ్ గురించి అడగండి", placeholder: "మీ ప్రశ్న టైప్ చేయండి…",
      hello: "నమస్తే! 🙏 OGO సేవలు, ధరలు లేదా బుకింగ్ గురించి ఏదైనా అడగండి.",
    },
  },
};
